// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @26.11.2021 13:30:55
import { CPatientHistory_abstract } from './../../abstract/SagaSchema/History/CPatientHistory_abstract';

export class CPatientHistory extends CPatientHistory_abstract {}
